import React from 'react';
import { Box } from '@styleseat/ui';
import { BodyText, Touchable } from '../../ui';
import { AdminTheme } from '../helpers';

interface ActionLinkProps {
  onClick: () => void;
  testID?: string;
}

export const ActionLink: React.FCWithChildren<ActionLinkProps> = ({
  children,
  onClick,
  testID,
}) => (
  <Touchable onClick={onClick} testID={testID}>
    <Box>
      <BodyText weight={AdminTheme.LinkFontWeight} color={AdminTheme.LinkColor}>
        {children}
      </BodyText>
    </Box>
  </Touchable>
);
